import { ValueOf } from "../type";

export const FolderSharingLinkKey = {
  FolderSharingLink: "FOLDER_SHARING_LINK",
  FolderFileDocsPdfPageBySharingLink: "FOLDER_FILE_DOCS_PDF_PAGE_BY_SHARING_LINK",
} as const;

export type FolderSharingLinkKeyType = ValueOf<typeof FolderSharingLinkKey>;
